export default __webpack_public_path__ + "static/media/stm bisnis.ea9a6ab0.png";